import { useEffect, useState } from 'react';

import { DataFetcher } from '@provider-portal/common/api/apiFetcher/createFetcher';
import {
  GetPromotionsPermissionsRequest,
  GetPromotionsPermissionsResponse,
  PromotionAccessType,
} from '@provider-portal/common/api/gen/CampaignDeliveryProvider';

export interface PromotionSettings {
  net_revenue_uplift: number;
  promotion_access_type: PromotionAccessType | null;
}

export function usePromotionSettingsLoader(
  providerId: number,
  promotionPermissionsFetcher: DataFetcher<
    GetPromotionsPermissionsResponse,
    [request: GetPromotionsPermissionsRequest]
  >,
): PromotionSettings {
  const [promotionSettings, setPromotionSettings] = useState<PromotionSettings>({
    net_revenue_uplift: 0,
    promotion_access_type: null,
  });

  useEffect(() => {
    promotionPermissionsFetcher
      .fetch({ provider_id: providerId })
      .then(({ result }) => {
        setPromotionSettings({
          net_revenue_uplift: result.net_revenue_uplift ?? 0,
          promotion_access_type: result.promotion_access_type,
        });
      })
      .catch(() => {});
  }, [promotionPermissionsFetcher, providerId]);
  return promotionSettings;
}
